export default "__VITE_ASSET__URaaPULU__"